<template>
  <div class="bg">
    <div class="content">
      <el-form :model="detailInfo" label-width="auto" label-position="left">
        <el-card>
          <el-form-item label="所属项目：">
            <span>
              {{ project }}
            </span>
          </el-form-item>
          <el-form-item label="设备名称：">
            <span>
              {{ detailInfo.name }}
            </span>
          </el-form-item>
          <el-form-item label="设备编号：">
            <span>
              {{ detailInfo.sn }}
            </span>
          </el-form-item>
          <el-form-item label="设备型号：">
            <span>{{ detailInfo.model }}</span>
          </el-form-item>
          <el-form-item label="进出类型：">
            <span>{{ detailInfo.inOut }}</span>
          </el-form-item>
          <el-form-item label="使用状态：">
            <span v-if="detailInfo.status == 1">正常</span>
            <span v-if="detailInfo.status == 2">拆除</span>
          </el-form-item>
          <el-form-item label="设备密码：">
            <span v-if="detailInfo.password == ''">无</span>
            <span v-else>
              {{ detailInfo.password }}
            </span>
          </el-form-item>
          <el-form-item label="设备IP：">
            <span>
              {{ detailInfo.ip }}
            </span>
          </el-form-item>
          <el-form-item label="生产日期：">
            <span>{{ detailInfo.manufactureDate }}</span>
          </el-form-item>
          <el-form-item label="安装位置：">
            <span>
              {{ detailInfo.installPosition }}
            </span>
          </el-form-item>
          <el-form-item label="备注信息：">
            <span v-if="detailInfo.remark == ''">无</span>
            <span v-else>
              {{ detailInfo.remark }}
            </span>
          </el-form-item>
        </el-card>
      </el-form>
    </div>
  </div>
</template>
<script>
import { postDictCode } from "@/api/dict";
import { postListUnit } from "@/api/app/unit";
import { postDetail } from "@/api/app/equipment";
import { postProjectId } from "@/api/app/project";
export default {
  data() {
    return {
      project: "",
      unit: "",
      idType: "",
      inOut: "",
      detailInfo: {},
    };
  },
  created() {
    this.detail();
  },
  methods: {
    detail() {
      // 所属项目
      postProjectId(this.$store.state.app.projectId).then((a) => {
        this.project = a.data.name;
      });
      // 通过列表id获取考勤设备详细信息
      postDetail(this.$store.state.app.itemId).then((b) => {
        // 设备型号
        postDictCode("equipment_model").then((c) => {
          c.data.find((d) => {
            if (b.data.type == d.value) {
              this.detailInfo["model"] = d.label;
            }
          });
          // 进出类型
          this.$store.state.app.dict.find((item) => {
            if (item.value == b.data.inOut) {
              this.detailInfo["inOut"] = item.label;
            }
          });
          // 使用状态
        });
        this.detailInfo = b.data;
      });
    },
  },
};
</script>
<style lang="less" scoped>
.bg {
  margin-bottom: 50px;
  padding: 10px;
  min-height: 100vh;

  background-color: #f0f0f0;
}
.content {
  .el-form-item {
    margin: 0px;
    font-size: 14px;
  }
  p {
    i {
      font-size: 12px;
    }
  }
  .img {
    img {
      width: 150px;
      height: 100%;
    }
  }
  /deep/ .el-input__inner {
    border: unset;
    padding: 0;
  }
}
</style>
